import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";

// Applies a creator's discount code when a visitor arrives via /?ref=<handle>.
export const RefCapture = () => {
  const { setCode } = useCart();
  const done = useRef(false);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (!ref || done.current) return;
    done.current = true;
    params.delete("ref");
    window.history.replaceState(null, "", window.location.pathname + (params.toString() ? `?${params}` : ""));
    api
      .post(`/ref/${encodeURIComponent(ref)}/visit`)
      .then(({ data }) => {
        setCode(data.code);
        localStorage.setItem("pettok_ref", ref.toLowerCase());
        toast.success(`@${ref} sent you 10% off. Code ${data.code} is in your cart.`);
      })
      .catch(() => {});
  }, [setCode]);
  return null;
};
